<template>
	<NP-Modal v-if="active">
		<div class="wrap">
			<img :src="modalError" />
			<h3>Увага</h3>
			<span>
				На відділенні переліміт готівки {{ issueAmount | formatMoney }} грн.<br />
				Не забудьте інкасувати або видати надлишок
			</span>
		</div>
		<div class="buttons">
			<NP-Button priority="high" @click="confirm"> Зрозуміло </NP-Button>
		</div>
	</NP-Modal>
</template>
<script>
import modalError from '@assets/images/modal-error.svg';

export default {
	name: 'AlertModal',
	data() {
		return {
			modalError,
			active: false,
			resolve: null,
			issueAmount: 0
		};
	},
	methods: {
		show(amount) {
			this.issueAmount = amount;

			this.$nextTick(() => {
				this.active = true;
			});

			return new Promise((resolve) => {
				this.resolve = resolve;
			});
		},
		confirm() {
			this.active = false;
			this.resolve(true);
		}
	}
};
</script>
<style lang="scss" scoped>
@import '@assets/scss/variables';
@import '@assets/scss/mixins';

$icon-close: '~@assets/images/icon-close.svg';

::v-deep .modal-container {
	width: 413px;
	border-top: 2px solid $red !important;
	.modal-body {
		padding: 0px !important;
	}
}
.wrap {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	padding: 0 38px;
	span,
	h3 {
		text-align: center;
		margin-bottom: 15px;
	}
	h3 {
		color: $red;
	}
	span {
		font-size: 14px;
	}
}
.buttons {
	display: flex;
	justify-content: center;
	padding: 24px;
	.icon-close {
		@include make-icon($icon-close, $gray-40, 20px, 20px);
	}
}
</style>
